<template>
    <div class="l-panel search-component" ref="searchBarComponent">
      <!--  <div class="panel-head" v-show="!hideSearchHeader" ref="searchBarComponentHead"> -->
         <!--  <i class="el-icon-remove-outline"></i> -->
            <!-- <div class="title" style="text-align: left;">
              <i :class="['icon icon-left', showSearchBar ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline']" @click="handleCollapse" v-show="!hideCollapseHandle" :title="showSearchBar ? '收起': '展开'"></i>操作
             -->
               <!-- <span class="handle-collapse" @click="handleCollapse" v-show="!hideCollapseHandle" :title="showSearchBar ? '收起': '展开'">
                  <!--  <i :class="['icon icon-left iconfont', showSearchBar ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline']"></i> -->
                    <!-- <i class="el-icon-remove-outline"></i>
                </span>
                <i v-show="hideCollapseHandle" class="el-icon-search"></i>
                操作 -->
            <!-- </div> -->
            <!-- 搜索栏操作按钮 START -->
    <!--        <div class="handle-tool">
                <slot name="search-tool"></slot>
            </div> -->
            <!-- 搜索栏操作按钮 END -->
        <!-- </div> -->
        <el-collapse-transition>
            <div class="panel-body search-bar" v-show="showSearchBar">
                <slot name="search-cont"></slot>
            </div>
        </el-collapse-transition>
    </div>
</template>

<script>
export default {
    props: ['hideCollapse', 'hideHeader'],
    data() {
        return {
            hideSearchHeader: true, // 显示头部
            hideCollapseHandle: true, // 显示收展按钮
            showSearchBar: true, // 展开
            componentHeight: 0
        }
    },
    created() {
        this.$nextTick(() => {
            this.componentHeight = this.$refs.searchBarComponent.clientHeight;
        })
    },
    activated() {
        this.hideSearchHeader = this.hideHeader || false;
        this.hideCollapseHandle = this.hideCollapse || false;
    },
    methods: {
        handleCollapse() {
            this.showSearchBar = !this.showSearchBar;
            this.componentHeight = this.$refs.searchBarComponent.clientHeight > this.componentHeight ? this.$refs.searchBarComponent.clientHeight : this.componentHeight;
            let searchHeight = this.showSearchBar ? this.componentHeight : this.$refs.searchBarComponentHead.clientHeight;
            this.$emit('searchBarHeight', searchHeight);
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>



// WEBPACK FOOTER //
// src/components/searchBar/index.vue